const addClasses = (element, classes) => {
    classes.forEach(className => {
        element.classList.add(className);
    });
};

class SearchAiModal {

    constructor() {
        this.isOpen = false;
        this.isAnimating = false;
        this.backdrop = document.createElement('div');
        addClasses(this.backdrop, ['search-modal-backdrop', 'd-none']);
        document.body.appendChild(this.backdrop);
    }

    init(openButton, modal, input) {
        this.openButton = openButton;
        this.modal = modal;
        this.input = input;
        const closeBtn = document.querySelector('.modal-close-btn');

        addClasses(this.modal, ['search-modal', 'd-none']);
        document.body.appendChild(this.modal);

        this.openButton.addEventListener('click', () => {
            if (!this.isAnimating) {
                this.toggleModal();
            }
        });

        document.addEventListener('mousedown', event => {
            if (
                this.isOpen
                && !event.target.closest('.search-modal')
                && !this.isAnimating
            ) {
                this.closeModal();
            }
        });

        closeBtn.addEventListener('click', () => {
            if (!this.isAnimating) {
                this.closeModal();
            }
        });

        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && this.isOpen && !this.isAnimating) {
                this.closeModal();
            }
        });
    }

    toggleModal() {
        if (this.isOpen) {
            this.closeModal();
        } else {
            this.openModal();
        }
    }

    openModal() {
        this.isAnimating = true;
        this.modal.classList.remove('d-none');
        this.backdrop.classList.remove('d-none');
        this.input.focus();
        setTimeout(() => {
            this.modal.classList.add('open');
            this.backdrop.classList.add('open');
            this.modal.addEventListener(
                'transitionend',
                () => {
                    this.isAnimating = false;
                    this.isOpen = true;
                },
                {once: true},
            );
        }, 50);
    }

    closeModal() {
        this.isAnimating = true;
        this.modal.classList.remove('open');
        this.backdrop.classList.remove('open');

        this.modal.addEventListener(
            'transitionend',
            () => {
                this.modal.classList.add('d-none');
                this.backdrop.classList.add('d-none');
                this.isAnimating = false;
                this.isOpen = false;
            },
            {once: true},
        );
    }

}

export default SearchAiModal;
